import App from "../vue/MainApp.js";

(function () {
	App();
})();
